import { format, lastDayOfMonth, startOfMonth, subMonths } from "date-fns"

export const montarParametrosBusca = (selectedDate, idsUnidade, agora = new Date()) => {
    const startOfMonthFormattedStore = format(startOfMonth(subMonths(selectedDate, 5)), 'yyyy-MM-dd')
    const startOfMonthFormatted = format(startOfMonth(subMonths(selectedDate, 1)), 'yyyy-MM-dd')
    const lastDayOfMonthFormatted = format(lastDayOfMonth(selectedDate), 'yyyy-MM-dd')
    const today = format(selectedDate, 'yyyy-MM-dd')

    const ontem = new Date(selectedDate)
    ontem.setDate(selectedDate.getDate() - 1)
    const yesterday = format(ontem, 'yyyy-MM-dd')

    const isCurrentMonth =
        selectedDate.getMonth() === agora.getMonth() &&
        selectedDate.getFullYear() === agora.getFullYear()

    const params = {
        startDateLastSixMonth: startOfMonthFormattedStore,
        startDate: startOfMonthFormatted,
        endDate: lastDayOfMonthFormatted,
        today,
        yesterday,
        unidade: idsUnidade,
    }

    const cachedParams = isCurrentMonth
        ? { ...params, endDate: yesterday }
        : params

    const todayOnlyParams = isCurrentMonth
        ? {
            startDateLastSixMonth: today,
            startDate: today,
            endDate: today,
            today,
            yesterday,
            unidade: idsUnidade,
            noCacheRedis: true,
        }
        : null

    return { params, cachedParams, todayOnlyParams, isCurrentMonth }
}
